import { COMPLAINT_FORM_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const complaintForm = (props) => onResponse => {
    try {
        axiosInstance.post(COMPLAINT_FORM_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const complaintFormTask = () => onResponse => {
    try {
        axiosInstance.get(COMPLAINT_FORM_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};